<template>
    <div class="operator-layout">
        <Header></Header>
        <transition name="slide" mode="out-in">
            <slot></slot>
        </transition>
        <!-- Start Footer-->
        <Footer></Footer>
    </div>
</template>
<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
export default {
    name: "operator_layout",
    components: {
        Header,
        Footer
    }
};
</script>
<style scoped lang="scss">
:root{
  --auth-second-color: #0180D8;
  --auth-second-color-hover: #005c9e;
}
</style>